import { provideObjClass } from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { BuildingType } from "shared/types/references/BuildingType"

export const BuildingReferenceObjClass = provideObjClass("BuildingReference", {
  attributes: {
    ...defaultPageAttributes,
    referenceID: "string",
    planner: "string",
    owner: "string",
    architect: "string",
    contact: ["reference", { only: "ContactDetails" }],
    contactDetails: ["widgetlist", { only: "ContactDetailsWidget" }],
    locationContactDetails: ["widgetlist", { only: "ContactDetailsWidget" }],
    architectContactDetails: ["widgetlist", { only: "ContactDetailsWidget" }],
    clientContactDetails: ["widgetlist", { only: "ContactDetailsWidget" }],
    plannerContactDetails: ["widgetlist", { only: "ContactDetailsWidget" }],
    buildingType: ["multienum", { values: Object.values(BuildingType) }],
    images: ["referencelist", { only: "Image" }],
    imageWidgets: ["widgetlist", { only: "ImageWidget" }],
    childOrder: "referencelist"
  },
  onlyChildren: ["InstallationReference"]
})

export type BuildingReferenceObj = InstanceType<
  typeof BuildingReferenceObjClass
>
